<mat-form-field class="syn--full-width" appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-select [(ngModel)]="language" [placeholder]="placeholder">
        <mat-option *ngFor="let lang of AVAILABLE_LANGUAGES" [value]="lang.code">
            <syn-language-flag [language]="lang.code"></syn-language-flag>
            {{ lang.name }}
        </mat-option>
    </mat-select>
</mat-form-field>
